import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import './Footer.scss';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const Footer = () => {
  /*const abrirAvisoPrivacidad = () => {
    window.open('https://www.prosamexico.mx/aviso-de-privacidad/', '_blank');
  };*/
  return (
    <>
      <Navbar expand="lg" className="footer">
        <Container className="px-5 py-2 justify-items-center">
          <Row className="w-100">
            <Col xs={12} className="text-center">
              {/*Modificacion: Marca de Inicio WII C-24-1229-24*/}
              <Link to={'/aviso-privacidad'}>Aviso de privacidad integral para colaboradores</Link>
              {/*Modificacion: Marca de Fin WII C-24-1229-24*/}
            </Col>
            <Col xs={12} className="text-center">
              <Link to={'/sobre-nosotros'}>Sobre nosotros</Link>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </>
  );
};
